import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { CreditMovementListStore } from "../../store/CreditMovementListStore";

type CreditMovementListDialogsProps = {
  store: CreditMovementListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de CreditMovement.
 * Separado para mantener CreditMovementListPage más limpio.
 */
export const CreditMovementListDialogs: React.FC<CreditMovementListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
